export default __webpack_public_path__ + "static/media/phone-sweepstakes-instructions.65c228c5.png";